import { Link } from "react-router-dom";
import logo from "../assets/img/logo4.png";

export function Footer() {
  const now = () => {
    return new Date().getFullYear();
  }
  return (
    <footer className="bg-[#0288d0] text-white py-8 mt-auto">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-2">
            <Link to="/" className="flex items-center gap-2">
              <img src={logo} alt="GeoGas Logo" className="h-16 w-auto" />
            </Link>
          </div>
          <div className="flex gap-6">
            <Link href="/terms" className="hover:underline">
              Términos de servicio
            </Link>
            <Link href="/privacy" className="hover:underline">
              Política de privacidad
            </Link>
            <Link href="/contact" className="hover:underline">
              Contacto
            </Link>
          </div>
        </div>
        <div className="text-center mt-4 text-sm opacity-80">© {now()} MIDJI. Todos los derechos reservados.</div>
      </div>
    </footer>
  )
}
